var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "hash",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.74181 0.0135963C8.69357 0.132568 9.36873 1.00062 9.24981 1.95243L8.84247 5.21066H13.447L13.9081 1.52157C14.0271 0.569759 14.8952 -0.105387 15.8469 0.0135963C16.7987 0.132568 17.4739 1.00062 17.355 1.95243L16.9476 5.21066H19.6839C20.6431 5.21066 21.4207 5.98825 21.4207 6.94747C21.4207 7.90669 20.6431 8.68429 19.6839 8.68429H16.5134L15.9345 13.3157H19.105C20.0642 13.3157 20.8418 14.0934 20.8418 15.0526C20.8418 16.0119 20.0642 16.7894 19.105 16.7894H15.5003L15.0392 20.4785C14.9202 21.4303 14.0521 22.1054 13.1003 21.9864C12.1486 21.8675 11.4734 20.9994 11.5923 20.0476L11.9997 16.7894H7.39516L6.93403 20.4785C6.81505 21.4303 5.94702 22.1054 4.99521 21.9864C4.0434 21.8675 3.36825 20.9994 3.48722 20.0476L3.8945 16.7894H1.73682C0.777595 16.7894 0 16.0119 0 15.0526C0 14.0934 0.777595 13.3157 1.73682 13.3157H4.3287L4.90764 8.68429H2.31575C1.35653 8.68429 0.578938 7.90669 0.578938 6.94747C0.578938 5.98825 1.35653 5.21066 2.31575 5.21066H5.34184L5.80298 1.52157C5.92195 0.569759 6.79 -0.105387 7.74181 0.0135963ZM12.4339 13.3157L13.0128 8.68429H8.40827L7.82937 13.3157H12.4339Z",
    fill: "#A9A7A7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHash);
export default __webpack_public_path__ + "static/media/hash.3bd6797a8cf1090ef698089166310c34.svg";
export { ForwardRef as ReactComponent };